import { observer } from "mobx-react";
import { useRef } from "react";
import { useEffect } from "react";
import { getPaddleCheckoutAttributes } from "../../../../others";
const ChangePaymentDetailsModalContentPaddle = observer(_ref => {
  let {
    onLoaded,
    onComplete,
    record
  } = _ref;
  const {
    Paddle,
    data: {
      ecommerceSystemSubscriptionId,
      paymentUpdateUrl
    }
  } = record;
  const ref = useRef();
  const frameTarget = `paddle-change-details-frame-${ecommerceSystemSubscriptionId}`;
  useEffect(() => {
    if (ref.current && Paddle) {
      Paddle.Checkout.open({
        ...getPaddleCheckoutAttributes(),
        // Override (https://developer.paddle.com/api-reference/product-api/pay-links/createpaylink)
        override: paymentUpdateUrl,
        // Iframe configuration
        frameTarget,
        loadCallback: onLoaded,
        successCallback: onComplete
      });
    }
  }, [ref, Paddle, frameTarget, paymentUpdateUrl]);
  return /*#__PURE__*/React.createElement("div", {
    className: frameTarget,
    ref: ref
  });
});
export { ChangePaymentDetailsModalContentPaddle };